/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateReportShareTokenQuery model module.
 * @module model/CreateReportShareTokenQuery
 * @version 0.0.1
 */
class CreateReportShareTokenQuery {
    /**
     * Constructs a new <code>CreateReportShareTokenQuery</code>.
     * @alias module:model/CreateReportShareTokenQuery
     */
    constructor() { 
        
        CreateReportShareTokenQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CreateReportShareTokenQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateReportShareTokenQuery} obj Optional instance to populate.
     * @return {module:model/CreateReportShareTokenQuery} The populated <code>CreateReportShareTokenQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateReportShareTokenQuery();

            if (data.hasOwnProperty('report')) {
                obj['report'] = ApiClient.convertToType(data['report'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('expiry')) {
                obj['expiry'] = ApiClient.convertToType(data['expiry'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreateReportShareTokenQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateReportShareTokenQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['report'] && !(typeof data['report'] === 'string' || data['report'] instanceof String)) {
            throw new Error("Expected the field `report` to be a primitive type in the JSON string but got " + data['report']);
        }
        // ensure the json data is a string
        if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
            throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
        }
        // ensure the json data is a string
        if (data['expiry'] && !(typeof data['expiry'] === 'string' || data['expiry'] instanceof String)) {
            throw new Error("Expected the field `expiry` to be a primitive type in the JSON string but got " + data['expiry']);
        }

        return true;
    }


}



/**
 * @member {String} report
 */
CreateReportShareTokenQuery.prototype['report'] = undefined;

/**
 * @member {String} label
 */
CreateReportShareTokenQuery.prototype['label'] = undefined;

/**
 * @member {String} expiry
 */
CreateReportShareTokenQuery.prototype['expiry'] = undefined;






export default CreateReportShareTokenQuery;

